import type { FC } from "react";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";

import { Lightbox } from "components/Lightbox";

interface Props {
  name: string;
  onClose: () => void;
  onConfirm: () => void;
  onShowExercises: () => void;
}

// AIDEV-NOTE: Žádný nadpis v obsahu — hlavička zůstává holá. Přístupné jméno bere
// `envelope:blackEnvelope.title` ("Tohle teď přeskočíme"), který v kódu jinak nikde
// nebyl zapojený (viditelný text je celý natvrdo). Pojmenování jde přes `ariaLabel`,
// ne `title`, aby se text nezobrazil v hlavičce — to by změnilo vzhled bez potvrzení
// návrhem. Zadavatel ať posoudí, jestli má klíč patřit rovnou do hlavičky. [TD-344]
const BlackEnvelopeTopic: FC<Props> = ({ name, onClose, onConfirm, onShowExercises }) => {
  const { t } = useTranslation(["envelope"]);

  return (
    <Lightbox
      onHide={onClose}
      show={true}
      bodyClassName="pt-0"
      ariaLabel={t("blackEnvelope.title", { ns: "envelope" })}
    >
      <p>
        Téma <strong>&quot;{name}&quot;</strong> je pro Tebe teď trochu náročné, odebrali jsme ho z procvičování.
      </p>
      <p>
        <strong>Prober ho s rodiči, učiteli nebo na doučování. Jakmile to budeš chápat, dej nám vědět!</strong>
      </p>

      <div className={"d-grid gap-8px"}>
        <Button className={"w-100"} onClick={onConfirm}>
          Doučil jsem se,
          <br />
          chci ho zařadit do procvičování
        </Button>
        <Button variant={"outline-secondary-darker"} className={"w-100"} onClick={onClose}>
          Pracuju na tom :)
        </Button>
        <Button variant={"outline-secondary-darker"} className={"w-100"} onClick={onShowExercises}>
          Zobrazit úlohy
        </Button>
      </div>
    </Lightbox>
  );
};

export default BlackEnvelopeTopic;
